import { Typography } from '@mui/material';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import { ERROR_BAR_HEIGHT } from '../../utils/defined';

const SubscriptionErrorBar = ({ message, onDismiss, offsetTop }) => {
  return (
    <div
      style={{
        position: 'sticky',
        top: offsetTop,
        minHeight: ERROR_BAR_HEIGHT,
        backgroundColor: '#D93025',
        borderBottom: '1px solid #B3261E',
        color: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        zIndex: 10000,
        borderTopLeftRadius: 'var(--sp-xxs)',
        borderTopRightRadius: 'var(--sp-xxs)'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingLeft: 'calc(var(--sp-md2) * 1.50943)',
          gap: 'var(--sp-md2)',
          flex: 1,
          minWidth: 0
        }}
      >
        <div
          style={{
            width: 'calc(var(--sp-md2) * 1.698113)',
            height: 'calc(var(--sp-md2) * 1.698113)',
            borderRadius: '50%',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          <PriorityHighRoundedIcon
            sx={{
              fontSize: 'calc(var(--fs-xs) * 1.32075)',
              color: '#D93025',
              transform: 'translateY(0.5px)'
            }}
          />
        </div>

        <Typography
          sx={{
            fontSize: 'calc(var(--fs-xs) * 1.415094)',
            lineHeight: 'calc(var(--fs-xs) * 1.698113)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: 500,
          }}
        >
          {message}
        </Typography>
      </div>

      <div
        onClick={onDismiss}
        style={{
          marginRight: 'calc(var(--sp-md2) * 1.50943)',
          padding: 'var(--sp-xxs) calc(var(--sp-md2) * 1.132075)',
          borderRadius: 'calc(var(--sp-lg) * 47.1264)',
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
          cursor: 'pointer',
          transition: 'background-color 0.2s ease',
          flexShrink: 0
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor =
            'rgba(255, 255, 255, 0.5)')
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor =
            'rgba(255, 255, 255, 0.4)')
        }
      >
        <Typography
          sx={{
            fontSize: 'calc(var(--fs-xs) * 1.32075)',
            fontWeight: 600,
            lineHeight: 'calc(var(--sp-md2) * 1.50943)'
          }}
        >
          Dismiss
        </Typography>
      </div>
    </div>
  );
};

export default SubscriptionErrorBar;
